import { BrowserCacheLocation, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalService
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '@lp/environment';
import { APP_ROUTES } from '@lp/routes';

function MSALInstanceFactory(): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      ...environment.msal.auth,
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    }
  });
}

function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    loginFailedRoute: `/${APP_ROUTES.error}`,
    authRequest: {
      scopes: ['user.read']
    }
  };
}

function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();
  protectedResourceMap.set(environment.msal.graphEndpoint, ['User.Read']);
  protectedResourceMap.set(environment.apiEndpoint, environment.msal.apiScopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function provideMSALAuthentication(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ]);
}
